module.exports = __webpack_public_path__ + "img/firework.76c365b4.png";